import { SET_RELATED } from 'reduxes/slices/related/actions'

export function related(state = {}, action) {
  switch (action.type) {
    case SET_RELATED:
      return setRelated(state, action)
    default:
      return state
  }
}

function setRelated(state, action) {
  return {
    ...state,
    [action.key]: action.related,
  }
}
